export default defineNuxtPlugin(() => {
	window.addEventListener("beforeunload", () => {
		const store = useMasterSSocketStore();
		store.close();
	});
});
